















import { computed, defineComponent } from '@vue/composition-api';
import { useNewProjectsStore } from '@/stores/new-project';

export default defineComponent({
  name: 'MailAccount',
  setup() {
    const newProjectsStore = useNewProjectsStore();
    const mailAccountSecrets = newProjectsStore.mailAccountSecrets;
    const mailAccountEnabled = computed<boolean>({
      get() {
        return newProjectsStore.mailAccountEnabled;
      },
      set(value) {
        newProjectsStore.setMailAccountEnabled(value);
      },
    });

    return {
      mailAccountSecrets,
      mailAccountEnabled,
    };
  },
});
